import { Manifesto } from "@/components/Manifesto";
import { TedxTalk } from "@/components/TedxTalk";

/**
 * Who she is: the method with its receipts, the biography, the record, and
 * the talk. The talk keeps its #talk anchor, so /about#talk plays it.
 */
export default function About() {
  return (
    <main className="bg-cream text-ink no-x pt-[76px]" data-testid="about-page">
      <Manifesto />
      <TedxTalk />
    </main>
  );
}
